import mixpanel from '@aqx-core/common/mixpanel';

import { eventNameHelper, userHelper } from '../helpers';
import { EFeaturePopupAction } from '../types';

class FeaturePopupAnalysisService {
  public trackPopupAction = (action: EFeaturePopupAction) => {
    const userAccountProperties = userHelper.createUserAccountProperties();
    mixpanel.track(eventNameHelper.mapFeaturePopupAction(action), {
      ...userAccountProperties
    });
  };
}

const featurePopupAnalysisService = new FeaturePopupAnalysisService();
export default featurePopupAnalysisService;
